import { Named } from '../base/named';

/*
    This is a framework class for managing dependencies. DO NOT use this class
    to get dependencies. You should use ModelService.references()
    or Walker.walk API to get dependencies
*/
export class Dependency {
    /*
        Stores dependencies on a named object
    */
    public static depend(named: Named, dependencies?: Set<Named>): Named {
        if (named.extension.$dependencies && !dependencies) {
            delete named.extension.$dependencies;
        } else if (dependencies) {
            named.extension.$dependencies = dependencies;
        }
        return named;
    }

    /*
        Get the current dependencies
    */
    public static dependencies(named: Named): Set<Named> | undefined {
        return named.extension.$dependencies as Set<Named>;
    }
}
